module.exports = __webpack_public_path__ + "static/media/f_eyeshape_almond_blue.c59c6990.png";